/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// import 'css/main'

import '@babel/polyfill'

import '../main'
import Jsona from 'jsona'
// import Rollbar from 'rollbar'
global.Jsona = Jsona

// global.Rollbar = Rollbar

require('lit-jsonapi-tools/jsonapi-resource')

require('@webcomponents/webcomponentsjs/webcomponents-bundle')
require('@polymer/polymer/polymer-element')
require('web-animations-js/web-animations.min')
require('web-animations-js/web-animations-next.min')
require('@polymer/neon-animation/neon-animations')
require('@polymer/iron-flex-layout/iron-flex-layout')
require('@polymer/iron-flex-layout/iron-flex-layout-classes')
require('@polymer/iron-list/iron-list')
require('@polymer/iron-location/iron-location')
require('@polymer/iron-ajax/iron-ajax')
require('@polymer/paper-card/paper-card')
require('@polymer/paper-progress/paper-progress')
require('@polymer/paper-spinner/paper-spinner')
require('@polymer/paper-toast/paper-toast')
require('@polymer/paper-toggle-button/paper-toggle-button')
require('@polymer/paper-styles/paper-styles')
require('@polymer/app-layout/app-layout')
require('@polymer/app-layout/app-drawer-layout/app-drawer-layout')
require('@polymer/app-layout/app-drawer/app-drawer')
require('@polymer/paper-header-panel/paper-header-panel')
require('@polymer/paper-drawer-panel/paper-drawer-panel')
require('@polymer/paper-toolbar/paper-toolbar')
require('@polymer/iron-collapse/iron-collapse')
require('@polymer/iron-image/iron-image')
require('@polymer/iron-icons/av-icons')
require('@polymer/iron-icons/social-icons')
require('@polymer/iron-icons/editor-icons')
require('@polymer/iron-icons/image-icons')
require('@polymer/iron-iconset-svg/iron-iconset-svg')
require('@polymer/iron-iconset/iron-iconset')
require('@moskito/moskito-iconset/moskito-iconset')
require('@polymer/iron-icons/iron-icons')
require('@polymer/paper-icon-button/paper-icon-button')
require('@polymer/paper-material/paper-material')
require('@polymer/paper-button/paper-button')
require('@polymer/paper-checkbox/paper-checkbox')
require('@polymer/paper-radio-button/paper-radio-button')
require('@polymer/paper-input/paper-input')
require('@polymer/paper-input/paper-input-container')
require('@polymer/paper-input/paper-textarea')
require('@polymer/paper-fab/paper-fab')
require('@polymer/iron-scroll-target-behavior/iron-scroll-target-behavior')
require('@polymer/iron-scroll-threshold/iron-scroll-threshold')
require('@polymer/paper-menu-button/paper-menu-button')
require('@polymer/paper-dropdown-menu/paper-dropdown-menu')
require('@polymer/paper-listbox/paper-listbox')
require('@polymer/iron-pages/iron-pages')
require('@polymer/paper-item/paper-item')
require('@polymer/paper-item/paper-item-body')
require('@polymer/paper-item/paper-icon-item')
require('@polymer/paper-tooltip/paper-tooltip')
require('@polymer/paper-dialog-scrollable/paper-dialog-scrollable')
require('@polymer/paper-dialog/paper-dialog')
require('@polymer/paper-tabs/paper-tabs')
require('@polymer/paper-tabs/paper-tab')
require('@polymer/paper-badge/paper-badge')
require('@polymer/app-route/app-location')
require('@polymer/app-route/app-route')

require('@vaadin/vaadin-date-picker/vaadin-date-picker')

require('@moskito/moskito-styles/moskito-styles')
require('@moskito/song-details-dialog/song-details-dialog')
require('@moskito/moskito-song-lyrics/moskito-song-lyrics')
require('@moskito/toolbar-menu/toolbar-menu')
require('@moskito/moskito-song-chordpro/moskito-song-chordpro')
require('@moskito/moskito-song-details/moskito-song-details')
require('@moskito/moskito-publishing-tree/moskito-publishing-tree')
require('@moskito/moskito-publishers-manager/moskito-publishers-manager')
require('@moskito/moskito-rights-manager/moskito-rights-manager')
require('@moskito/moskito-beneficiaries-picker/moskito-beneficiaries-picker')
require('@moskito/moskito-levies-manager/moskito-levies-manager')
require('@moskito/moskito-paper-fab/moskito-paper-fab')
require('@moskito/moskito-paper-fab-action/moskito-paper-fab-action')
require('@moskito/moskito-cookie-consent/moskito-cookie-consent')
require('@moskito/moskito-avatar/moskito-avatar')
require('@moskito/moskito-authors/moskito-authors')
require('@moskito/moskito-authors/moskito-author')
require('@moskito/moskito-drawer/moskito-drawer')
require('@moskito/moskito-rating/moskito-rating')
require('@moskito/moskito-rating/moskito-rating-bar')
require('@moskito/moskito-form-tools/moskito-address-form')
require('@moskito/moskito-form-tools/moskito-messenger')
require('@moskito/moskito-form-tools/moskito-search')
require('@moskito/moskito-subscriptions/moskito-subscription')
require('@moskito/moskito-payment/moskito-payment')

require('@material/select')

require('packs/global')
